// extracted by mini-css-extract-plugin
export default {"container":"CollectionPage_container__N4CG+"};